import { Checkbox, FormControlLabel } from "@material-ui/core";
import React from "react";
import "./accept-terms.less";
import { apiPost, apiRequest } from "../../utils/api_service";
import { API_HEADERS, API_URL } from "../../constants/api";
import OtpDialog from "../../components/common/otp-ui";
import { ShowToast, toastType } from "../../utils/toast-service";
import StreamLogo from "../../public/img/common/Stream-Data-Centers_Logo_WHITE.svg";
import axios from "axios";
import SuccessDialog from "../../components/common/success-dialogue";
import ToastMessage from "../../components/common/toastMsg";
import FullPageLoader from "../loader/fullPage-loader";
import moment from "moment";
class AbrfCheck extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: "",
      userEmailId: "",
      isAccept: false,
      isAuthorized: false,
      isOtpConfirmed: false,
      docuSignLink: "",
      displayInfoText: "",
      displayInfoIsError: false,
      signerName: "",
      tenantName: "",
      requestedForCompany: "",
      otpDialogMessage: "Enter OTP sent to your registered mail id."
    };
  }

  componentDidMount() {
    this.getAuthenticate();
  }

  /** Authentication */
  getAuthenticate = () => {
    const params = new URLSearchParams(document.location.search);
    let requestId = "";
    let email = "";
    if ((params.get("event")) !== "signing_complete") {
      try {
        requestId = !params.get("requestId") && window.atob(params.get("requestId")) === undefined ? "" : window.atob(params.get("requestId"));
        email = !params.get("email") || window.atob(params.get("email")) === undefined ? "" : window.atob(params.get("email"));

        if (!requestId || !email) {
          this.setState({ displayInfoText: "Your session is expired, please click on link received in Email.", displayInfoIsError: true });
          return;
        }
      } catch (err) {
        this.setState({ displayInfoText: "Your session is expired, please click on link received in Email.", displayInfoIsError: true });
        return;
      }

      const postBody = {
        requestId: requestId,
        userEmailId: email
      };
      apiPost({
        url: API_URL.brr.authenticateUrl,
        postBody: postBody,
        overrideHeaders: this.getHeaders()
      }).then(({ success: isExecuted, data }) => {
        if (data.data && data.data.IsAlreadySigned) {
          this.setState({ displayInfoText: "Document Already Signed.", displayInfoIsError: false });
        } else if (isExecuted) {
          this.setState({ 
            ...postBody, 
            isAuthorized: true, 
            signerName: data?.data?.RequestedFor,
            tenantName: data?.data?.TenantName,
            requestedForCompany: data?.data?.RequestedForCompany,
            otpDialogMessage: "Enter OTP sent to your registered mail id: "
            });
        } else {
          this.setState({ displayInfoText: "Invalid User Details", displayInfoIsError: true });
        }
      });
    } else {
      // After successfully complete DOcu sign
      let isSignedDocument = false;
      const envelopData = JSON.parse(localStorage.getItem("envelopData"));
      const params = {};
      
      const getParams = {};
      getParams.envelopId = envelopData.envelopeId;
      apiRequest({
        url: API_URL.brr.getEnvelopStatus,
        params: getParams,
        overrideHeaders: this.getHeaders()
      }).then(({ success, data: response }) => {
        if(success != true){
          this.setState({ displayInfoText: "Document is not signed yet.", displayInfoIsError: false });
          return;
        }
        isSignedDocument = success;
        params.requestId = envelopData.requestId;
        params.envelopId = envelopData.envelopeId;
        params.signerEmail = envelopData.signerEmail;
        params.isSignedDocument = isSignedDocument;
        params.signingDate = moment(response.lastModifiedDateTime).format("MM/DD/YYYY");
        apiPost({
          url: API_URL.brr.signedEnvelop,
          postBody: params,
          overrideHeaders: this.getHeaders()
        }).then(() => {
          if(isSignedDocument)
          {
            this.setState({ displayInfoText: "Document Signed Successfully.", displayInfoIsError: false });
          }
          else{
            this.setState({ displayInfoText: "Failed to Sign Document.", displayInfoIsError: false });
          }
        })
      })
    }
  };

  /** Email encoding */
  encodeEmail = (emailText) => {
    const email = emailText.split("@");
    const domain = email[1];
    const firstName = email[0];
    const b = firstName.substring(2, firstName.length);
    const c = "*";
    const cc = c.repeat(firstName.length - 2);
    const encoded = firstName.replace(b, cc);
    const arr = [];
    arr.push(encoded);
    arr.push(domain);
    
    return arr.join("@");
  }

  /** Otp validation */
  onOTPSubmit = (otp = "") => {
    const { requestId, userEmailId } = this.state;
    const postBody = {
      requestId, userEmailId, otp: otp + "", isResent: false
    };
    apiPost({
      url: API_URL.brr.verifyBRROtp,
      postBody: postBody,
    }).then(({ success: isExecuted, data, }) => {
      if (isExecuted) {
        localStorage.setItem("brr.IdToken", data.data.jwtToken);
        // ShowToast("OTP has been successfully verified.", toastType.SUCCESS, 5000, 200);
        this.setState({ isOtpConfirmed: true }, () => {
          this.generateBrrLink();
        });
      } else {
        ShowToast("Invalid OTP! Please enter correct One Time Password.", toastType.ERROR, 5000, 200);
      }
    });
  }

  /** Resend OTP */
  onOTPResend = (otp = "") => {
    const { requestId, userEmailId } = this.state;
    const postBody = {
      requestId, userEmailId, otp: otp + "", isResent: true
    };
    apiPost({
      url: API_URL.brr.resentBrrOtp,
      postBody: postBody,
      overrideHeaders: this.getHeaders()
    }).then(({ success: isExecuted }) => {
      if(isExecuted) {
        ShowToast("OTP resent successfully. Please check registered email id.", toastType.SUCCESS, 5000, 200);
        
      }
     });
  }

  /** Generate BRR link */
  generateBrrLink = () => {
    const headers = this.getHeaders();
    const url = API_URL.brr.generateBRRLink + "?signerEmail=" + this.state.userEmailId + "&signerName=" + this.state.signerName + "&requestId="
      + this.state.requestId + "&dsReturnUrl=" + window.location.href + "&dsPingUrl=" + window.location.href + "&tenantName=" + this.state.tenantName + "&companyName=" + this.state.requestedForCompany;
    headers.isHideLoader = false;
    axios({
      url: url,
      method: "get",
      headers
    })
      .then(response => {
      //  console.log(response)
        localStorage.setItem("envelopData", JSON.stringify(response.data.data));
        if (response.data) {
          this.setState({ docuSignLink: response.data.data.redirectUrl });
        }
      })
      .catch(() => {
        // console.log(err);
      });
  }

  /** Headers */
  getHeaders() {
    return {
      authorization: `${API_HEADERS.authName} ${localStorage.getItem(
        "brr.IdToken"
      )}`,
      cloudOrgId: 2,//localStorage.getItem(API_HEADERS.CID),
      CID: 2,  //localStorage.getItem(API_HEADERS.CID),
      // AGI: localStorage.getItem(API_HEADERS.AGI),
      "Cache-Control":  "no-cache"
    };
  }

  /** code for close the BRR signed page */
  closeWindow = () => { 
    window.open("","_parent",""); 
    window.close(); 
  }
  

  render() {
    const { isAccept, isOtpConfirmed, docuSignLink, displayInfoText, isAuthorized, displayInfoIsError } = this.state;
    return (
      <>
        <div className={"terms-cond-container"}>
          <ToastMessage />
          <FullPageLoader requestCount={isAuthorized || displayInfoText ? 0 : 1} />
          {
            displayInfoText && <SuccessDialog isError={displayInfoIsError} isOpen infoText={displayInfoText} OnHandelClick={() => this.closeWindow()} AgreeText={""} />
          }
          {
            !isOtpConfirmed && isAuthorized && <OtpDialog encodedEmail={this.encodeEmail(this.state.userEmailId)} otpMessage={this.state.otpDialogMessage} onSubmit={this.onOTPSubmit} onResend={this.onOTPResend} />
          }
          {/* {
            isDocumentSigned && !isAuthorized && <SuccessDialog isOpen={isDocumentSigned} detailInfoText="Document Signed Successfully." OnHandelClick={() => window.close()} AgreeText="" />
          } */}
          <div className={"layout-topBar"}>
            <div className={"img-logo"}><img src={StreamLogo} alt={"logo"} className={"stream-logo"} /></div>
            <div className={"app-name-title"}>{"DATA CENTER OPERATIONS PORTAL"}</div>
          </div>
          <div>
            <div className={"row login-area-glass"}>
              <div className={"col-xs-12 content page-title"}>{"Building Rules & Regulations "}</div>
              <div className={"col-xs-12 content center-xs"}>
                {
                  isOtpConfirmed && <iframe
                    src={"public/releases/abrf/BRR_Rules.pdf#zoom=100"}
                    width={"100%"}
                    height={"28500px"}
                    scrolling={"auto"}
                    className={"pdfPreview"}
                                    />
                }
              </div>
            </div>
            <div className={"row col-xs-12 mt-10 middle-xs checkMark-container"}>
              <div className={"col-xs-7 content center-xs"}>
                {isOtpConfirmed && <FormControlLabel
                  className={"checkMark"}
                  control={
                    <Checkbox checked={isAccept} onChange={(e) => this.setState({ isAccept: e.target.checked })} style={{ color: "red" }} />
                  }
                  label={"I agree to abide by all Building Rules and Regulations defined in the \"SDC Tech-ISMS Building Rules and Regulations Handbook.\""}
                                   />}
              </div>
              <div className={"col-xs-5 content middle-xs docu-sign"}>
                {
                  isAccept  && (docuSignLink && docuSignLink.length > 0) ? <a href={docuSignLink} target={"_self"} style={{ cursor: "pointer" }}>{"Click Here to Sign BRR Form"}</a> : ""
                }
              </div>
            </div>
          </div>
          {/* <div>
          <Footer />
        </div> */}
        </div>
      </>
    );
  }
}

export default AbrfCheck;
